export default __webpack_public_path__ + "static/media/ks.a4c12e72.png";